import { render, staticRenderFns } from "./QuestionCardHeader.vue?vue&type=template&id=1e140a69&"
import script from "./QuestionCardHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports